export default "__VITE_ASSET__DikVbZ68__ 640w, __VITE_ASSET__D5r5MkDv__ 1024w, __VITE_ASSET__SxaYpjC4__ 1536w";